import throttle from 'lodash/throttle'
export default class Motion {
    constructor(params = {}) {

        this.friction = .6
        this.acceleration = 0.15
        this.velocity = 0

        this.to = 1

        this.current = 1
        this.onProgress = () => {}
        this.onEnd = () => {}

        this.isRunning = false

        this.raf = null

        this.set(params)
    }

    animate() {
        const distance = this.getCurrent()
        this.render()

        const rafCallback = throttle(() => requestAnimationFrame(() => this.animate()), 1000/60)

        if (Math.abs(distance) > 0.00001) {
            rafCallback()
        } else {
            this.isRunning = false
            this.current = this.to
            this.render()
            this.onEnd()
        }
    }

    set(params) {
        Object.keys(params).forEach(key => {
            this[key] = params[key]
        })
    }

    getCurrent() {
        const distance = this.to - this.current
        const attraction = distance * this.acceleration

        this.velocity += attraction

        this.velocity *= this.friction
        this.current += this.velocity

        return distance
    }

    render() {
        this.onProgress(this.current)
    }

    getProgress() {
        this.animate()
    }

    start() {
        if (this.isRunning) {
            return
        }
        this.velocity = 0
        this.isRunning = true
        this.animate()
    }
}